module.exports = [
  require('./abi_dalzim_s_horrid_wilting'),
  require('./absorb_elements'),
  require('./aganazzar_s_scorcher'),
]
